module.exports = "/assets/75f3cd6f79353fbab45af89497745843.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/3P.png
// module id = 1016
// module chunks = 0